import {
  Badge,
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@bolt/components";
import "./ModelDropdown.css";
import React, { PropsWithChildren } from "react";
import { getModelDescriptionById } from "../../utils";
import { ModelProviders } from "../../types";
import { formatFileType } from "../../utils/formatFileType";

type ModelDropdownProps = {
  selectedModel: string;
  providers: ModelProviders;
  onChange: (model: string) => void;
};

export const ModelDropdown = ({ selectedModel, providers, onChange }: PropsWithChildren<ModelDropdownProps>) => {
  return (
    <div className="model-dropdown-container">
      <DropdownMenu>
        <span className="InterRegular tw-text-xs">Current model</span>
        <DropdownMenuTrigger asChild>
          <Button size="md" intent="neutral" iconRight="chevron-down" variant="ghost" className="model-dropdown-button">
            <span className="InterBold tw-text-sm">{getModelDescriptionById(selectedModel).name}</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start">
          {providers.providers.map((provider, index) => (
            <div key={provider.providerName} className="model-dropdown-group">
              {index !== 0 && <DropdownMenuSeparator key={`${index}_separator`} />}
              <DropdownMenuLabel>{provider.providerName}</DropdownMenuLabel>
              {provider.models.map((model) => (
                <DropdownMenuItem
                  checked={model.modelId === selectedModel}
                  key={model.modelId}
                  className="model-dropdown-select-item"
                  onSelect={() => onChange(model.modelId)}
                >
                  <div className="model-dropdown-model-name">
                    <span className="model-dropdown-model-name-title">{model.name}</span>
                    <div className="model-dropdown-model-labels">
                      {model.supportedFileTypes.map((fileName) => (
                        <Badge
                          shape="round"
                          size="sm"
                          className="tw-bg-transparent tw-cursor-pointer model-dropdown-file-support-badge"
                          key={fileName}
                        >
                          {formatFileType(fileName)}
                        </Badge>
                      ))}
                    </div>
                  </div>

                  {model.description && (
                    <span className="model-dropdown-model-description InterLight tw-text-xs">{model.description}</span>
                  )}
                </DropdownMenuItem>
              ))}
            </div>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
